/* src/app/layout/components/footer/footer.component.scss */
:host {
  display: flex;
  flex: 0 0 auto;
  z-index: 3;
}
:host .mat-toolbar {
  background: inherit;
  color: inherit;
  box-shadow:
    0px -1px 1px -1px rgba(0, 0, 0, 0.2),
    0px 0px 1px 0px rgba(0, 0, 0, 0.14),
    0px -1px 3px 0px rgba(0, 0, 0, 0.12);
}
:host.above {
  position: relative;
  z-index: 99;
}
/*# sourceMappingURL=data:application/json;base64,ewogICJ2ZXJzaW9uIjogMywKICAic291cmNlcyI6IFsic3JjL2FwcC9sYXlvdXQvY29tcG9uZW50cy9mb290ZXIvZm9vdGVyLmNvbXBvbmVudC5zY3NzIl0sCiAgInNvdXJjZXNDb250ZW50IjogWyI6aG9zdCB7XG4gICAgZGlzcGxheTogZmxleDtcbiAgICBmbGV4OiAwIDAgYXV0bztcbiAgICB6LWluZGV4OiAzO1xuXG4gICAgLm1hdC10b29sYmFyIHtcbiAgICAgICAgYmFja2dyb3VuZDogaW5oZXJpdDtcbiAgICAgICAgY29sb3I6IGluaGVyaXQ7XG4gICAgICAgIGJveC1zaGFkb3c6XG4gICAgICAgICAgICAwcHggLTFweCAxcHggLTFweCByZ2JhKDAsIDAsIDAsIDAuMiksXG4gICAgICAgICAgICAwcHggMHB4IDFweCAwcHggcmdiYSgwLCAwLCAwLCAwLjE0KSxcbiAgICAgICAgICAgIDBweCAtMXB4IDNweCAwcHggcmdiYSgwLCAwLCAwLCAwLjEyKTtcbiAgICB9XG5cbiAgICAmLmFib3ZlIHtcbiAgICAgICAgcG9zaXRpb246IHJlbGF0aXZlO1xuICAgICAgICB6LWluZGV4OiA5OTtcbiAgICB9XG59XG4iXSwKICAibWFwcGluZ3MiOiAiO0FBQUE7QUFDSSxXQUFBO0FBQ0EsUUFBQSxFQUFBLEVBQUE7QUFDQSxXQUFBOztBQUVBLE1BQUEsQ0FBQTtBQUNJLGNBQUE7QUFDQSxTQUFBO0FBQ0E7SUFDSSxJQUFBLEtBQUEsSUFBQSxLQUFBLEtBQUEsQ0FBQSxFQUFBLENBQUEsRUFBQSxDQUFBLEVBQUEsSUFBQTtJQUFBLElBQUEsSUFBQSxJQUFBLElBQUEsS0FBQSxDQUFBLEVBQUEsQ0FBQSxFQUFBLENBQUEsRUFBQSxLQUFBO0lBQUEsSUFBQSxLQUFBLElBQUEsSUFBQSxLQUFBLENBQUEsRUFBQSxDQUFBLEVBQUEsQ0FBQSxFQUFBOztBQUtSLEtBQUEsQ0FBQTtBQUNJLFlBQUE7QUFDQSxXQUFBOzsiLAogICJuYW1lcyI6IFtdCn0K */
